import { Link, graphql,useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import FBLogo from './vectors/fb-logo'
import TwitterLogo from './vectors/twitter-logo'
import "./layout.scss"
import Map from './map'


export default function Footer() {

    const data = useStaticQuery(
        graphql`
        query {
            map:  file(relativePath: {eq: "map.png"}) {
                childImageSharp{
                    fluid {
                        ...GatsbyImageSharpFluid_noBase64
                    }
                }
            }
        }
        `
    )


    return (
     <section>
     <footer>
     <div className="footer-content-wrapper">
         <div className='quicklinks'>
             <p>Quick Links</p>
             <ul>
                 <li>
                     <Link to='/'>Home</Link></li>
                     <li><Link to='/our_services'>Our Services</Link></li>
                     <li><Link to='/our_vehicles'>Our Vehicles</Link></li>
                     <li><Link to='/installations'>Retail Installations</Link></li>
                     <li><Link to='/about_us'>About Us</Link></li>
                     <li><Link to='/contact'>Contact Us</Link></li>
                     <li><Link to='/quote_request'>Request Quote</Link>
                 </li>
                     <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                     <li><Link to='/terms-of-service'>Terms of Service</Link></li>
             </ul>
         </div>
         <div className='mapcontainer'>
        <p>Our Location</p>
         {/* <a href="https://g.page/haslamlogistics?share" aria-label='link to map'>
             
        <Img fluid={data.map.childImageSharp.fluid} alt='map of head office' className='map'/>
         </a> */}

         <Map />
         
         
         </div>
         <div className='socials'><p>Get in touch</p>
         <div className="social-icons">
            <a href="http://facebook.com"  target="_blank"><FBLogo aria-label='go to our facebook page' className='social-icon'/></a>
            <a href="http://twitter.com"  target="_blank"><TwitterLogo aria-label='got to our twitter page' className='social-icon'/></a>
         </div>
         </div>
</div>
          <p className='company-info'>All rights reserved.</p>
          <p className='company-info'>© {new Date().getFullYear()} Haslam Logistics Ltd | 11445333</p>
          <p className='company-info'>Unit 18, Slough Business Park, 94 Farnham Rd, Slough SL1 3FQ</p>
          
        </footer>
     </section>
    )
}